import _ from 'lodash';

const state = {};

const actions = {
  handleServiceException({ dispatch, commit }, { e, router = null }) {
    if (e.response) {
      const responseData = e.response.data || {};
      const status = responseData.status || e.response.status;
      const data = responseData.data || responseData.errors || responseData;

      let errorMessages = [];
      if (status === 422) {
        if (_.isArray(data)) {
          errorMessages = data.map(item => item.msg || item.message || item).filter(Boolean);
        } else if (_.isString(data)) {
          errorMessages = [data];
        } else if (_.isObject(data)) {
          errorMessages = _.reduce(
            data,
            (messages, tmpData) => {
              if (_.isArray(tmpData)) {
                messages.push(...tmpData.map(item => item.msg || item.message || item).filter(Boolean));
              } else if (_.isObject(tmpData)) {
                messages.push(tmpData.msg || tmpData.message || JSON.stringify(tmpData));
              } else if (tmpData) {
                messages.push(tmpData);
              }
              return messages;
            },
            []
          );
        }

        commit(
          'alert/setMessage',
          { type: 'error', message: _.join(errorMessages, '\r\n') || responseData.message || 'Validation failed.' },
          { root: true }
        );
      } else if (status === 403) {
        dispatch('auth/sessionExpired', { router }, { root: true });
      } else {
        dispatch(
          'alert/error',
          { showType: 'toast', title: 'Error', text: responseData.message || e.message || 'API request failed.' },
          { root: true }
        );
      }
    } else {
      dispatch('alert/error', { showType: 'toast', title: 'Error', text: e.message }, { root: true });
    }
  }
};

const getters = {};

const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
